// extracted by mini-css-extract-plugin
export var alertIcon = "_rd-0";